import PageTitle from "../../../fragments/PageTitle";
import classes from '../ChangePage.module.css'

export default function ChangePageTitleSimple({openListHandler, isListOpened}) {
    return <PageTitle>
        <div className={`${classes.title_button_container} `}>
            <div className={classes.title_button_container_text}>Select WorkQ</div>
            <button onClick={openListHandler} className={`${classes.title_button} ${isListOpened ? classes.button_disabled : ''}`}>                
                <span className={classes.list_status_indicator}><i className="ti ti-chevron-down"></i></span>
            </button>   

            {/* {loading && <div className={classes.loading_container}> 
                <LoadingSpinner white={true}/>
                <span className={classes.loading_text}>Loading...</span>    
            </div> } */}
        </div>
    </PageTitle>
}